import { cn } from "@/client/lib/utils";

/**
 * Mantle wordmark lockup (mark + wordmark) from the brand handoff. The asset is
 * theme-baked - ink wordmark on light, white on dark - so we render both and let
 * the active theme reveal the right one (Tailwind `dark:` keys on the `.dark`
 * class set on <html>). Width is driven by the caller via `className`.
 */
export function BrandWordmark({ className }: { className?: string }) {
  return (
    <span className={cn("inline-block", className)}>
      <img
        src="/brand/mantle-logo-amber-on-light.svg"
        alt="Mantle"
        className="block h-auto w-full dark:hidden"
      />
      <img
        src="/brand/mantle-logo-amber-on-dark.svg"
        alt=""
        aria-hidden
        className="hidden h-auto w-full dark:block"
      />
    </span>
  );
}

/** The Mantle symbol (amber mark only), for tight spots like the mobile bar. */
export function BrandMark({ className }: { className?: string }) {
  return <img src="/brand/mantle-symbol.svg" alt="Mantle" className={className} />;
}
